// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-phone-inner {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 16px; 
    width: 100%;
    height: auto;
    padding: 0px 15px;
}

.branding {
    margin: 10px 0;
    color: white;
}

.mobile-menu {
    display: none;
}

.hamburger {
    background: none;
    border: none;
    cursor: pointer;
    padding: 10px;
}

.bar {
    display: block;
    width: 25px;
    height: 3px;
  background:#2BA769;
    margin: 5px 0;
    transition: 0.3s;
}

.hamburger.active .bar:nth-child(1) {
    transform: translateY(8px) rotate(45deg);
}

.hamburger.active .bar:nth-child(2) {
    opacity: 0;
}

.header{
    padding-bottom: 10px;
    border-bottom: 1px solid rgba(0,0,0,.25);
}

.hamburger.active .bar:nth-child(3) {
    transform: translateY(-8px) rotate(-45deg);
}

/* Mobile Sidebar */
.mobile-sidebar {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999 !important;
    right: -100%;
    width: 85%;
    max-width: 360px;
    height: 100vh;
    background: white;
    box-shadow: -5px 0 25px rgba(0, 0, 0, 0.3);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    overflow-y: auto;
    border-left: 1px solid rgba(255, 255, 255, 0.05);
    pointer-events: none;
    color: black;
}

.mobile-sidebar.active {
    right: 0;
    pointer-events: auto;
}

.sidebar-content {
    padding: 1rem 2rem 3rem 2rem;
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
}

.close-button {
    position: absolute;
    top: 1rem;
    left: 1rem;
    background: none;
    border: none;
    color: #2BA769;
    font-size: 2rem;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 50%;
    transition: all 0.3s ease;
}

.close-button:hover {
    background-color: rgba(255, 255, 255, 0.1);
    transform: rotate(90deg);
}

.sidebar-menu {
    list-style: none;
    padding: 0;
    margin: 1rem 0;
}

.sidebar-item {
    margin-bottom: 0.5rem;
    transform: translateX(20px);
    opacity: 0;
    transition: all 0.3s ease;
}

.mobile-sidebar.active .sidebar-item {
    transform: translateX(0);
    opacity: 1;
}

/* Stagger animation for menu items */
.mobile-sidebar.active .sidebar-item:nth-child(1) {
    transition-delay: 0.1s;
}

.mobile-sidebar.active .sidebar-item:nth-child(2) {
    transition-delay: 0.15s;
}

.mobile-sidebar.active .sidebar-item:nth-child(3) {
    transition-delay: 0.2s;
}

.mobile-sidebar.active .sidebar-item:nth-child(4) {
    transition-delay: 0.25s;
}

.mobile-sidebar.active .sidebar-item:nth-child(5) {
    transition-delay: 0.3s;
}

.sidebar-item a {
    display: block;
    text-decoration: none;
    color: black;
    font-size: 1.1rem;
    padding: .8rem 1.5rem;
    border-radius: 12px;
    transition: all 0.3s ease;
    background: transparent;
    font-weight: 500;
    position: relative;
}

.sidebar-item a:hover {
   
    background: rgba(255, 51, 102, 0.1);
    transform: translateX(5px);
}

.sidebar-cta {
    margin-top: auto;
    padding: 2rem 1rem;
    text-align: center;
    border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.sidebar-cta .cta-button {
    display: inline-block;
    padding: 1rem 2rem;
    background: #00665e;
    text-decoration: none;
    border-radius: 8px;
    font-size: 1.1rem;
    transition: all 0.3s ease;
    width: 90%;
}

.sidebar-cta .cta-button:hover {
    border-radius: 0 !important;
    background-color: #0a0a0a !important;
    border: 1px solid #00ff00 !important; /* var(--dark-neon-green) جایگزین */
    color: #00ff00;
    box-shadow: 0 0 20px rgba(57, 255, 20, 0.3);
}

/* Responsive */
@media (max-width: 990px) {
    .mobile-menu {
        display: block;
    }
    
    .hamburger.active .bar:nth-child(1) {
        transform: translateY(8px) rotate(45deg);
    }
    
    .hamburger.active .bar:nth-child(2) {
        opacity: 0;
    }
    
    .hamburger.active .bar:nth-child(3) {
        transform: translateY(-8px) rotate(-45deg);
    }
}

@media (max-width: 480px) {
    .mobile-sidebar {
        width: 80%;
    }
 
    .nav-link{
       font-size: 13px;
           padding: 5px !important;
           margin:5px 10px !important;
    }
    .first-road{
        font-size: 13px;
    }
    .header-phone-inner{
        padding: 0 5px !important;
    }
}

@media (min-width: 480px) {
    .nav-tabs{
        justify-content: space-between;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/navbar.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;EACb,kBAAkB;IAChB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,oBAAoB;IACpB,wCAAwC;AAC5C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA,mBAAmB;AACnB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,wBAAwB;IACxB,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,0CAA0C;IAC1C,iDAAiD;IACjD,gBAAgB;IAChB,gDAAgD;IAChD,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,QAAQ;IACR,oBAAoB;AACxB;;AAEA;IACI,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,0CAA0C;IAC1C,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,UAAU;AACd;;AAEA,qCAAqC;AACrC;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;IACnB,yBAAyB;IACzB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,mCAAmC;IACnC,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,+CAA+C;AACnD;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B,oCAAoC;IACpC,oCAAoC,EAAE,mCAAmC;IACzE,cAAc;IACd,2CAA2C;AAC/C;;AAEA,eAAe;AACf;IACI;QACI,cAAc;IAClB;;IAEA;QACI,wCAAwC;IAC5C;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,0CAA0C;IAC9C;AACJ;;AAEA;IACI;QACI,UAAU;IACd;;IAEA;OACG,eAAe;WACX,uBAAuB;WACvB,0BAA0B;IACjC;IACA;QACI,eAAe;IACnB;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,8BAA8B;IAClC;AACJ","sourcesContent":[".header-phone-inner {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px; \n    width: 100%;\n    height: auto;\n    padding: 0px 15px;\n}\n\n.branding {\n    margin: 10px 0;\n    color: white;\n}\n\n.mobile-menu {\n    display: none;\n}\n\n.hamburger {\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 10px;\n}\n\n.bar {\n    display: block;\n    width: 25px;\n    height: 3px;\n  background:#2BA769;\n    margin: 5px 0;\n    transition: 0.3s;\n}\n\n.hamburger.active .bar:nth-child(1) {\n    transform: translateY(8px) rotate(45deg);\n}\n\n.hamburger.active .bar:nth-child(2) {\n    opacity: 0;\n}\n\n.header{\n    padding-bottom: 10px;\n    border-bottom: 1px solid rgba(0,0,0,.25);\n}\n\n.hamburger.active .bar:nth-child(3) {\n    transform: translateY(-8px) rotate(-45deg);\n}\n\n/* Mobile Sidebar */\n.mobile-sidebar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 9999 !important;\n    right: -100%;\n    width: 85%;\n    max-width: 360px;\n    height: 100vh;\n    background: white;\n    box-shadow: -5px 0 25px rgba(0, 0, 0, 0.3);\n    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n    overflow-y: auto;\n    border-left: 1px solid rgba(255, 255, 255, 0.05);\n    pointer-events: none;\n    color: black;\n}\n\n.mobile-sidebar.active {\n    right: 0;\n    pointer-events: auto;\n}\n\n.sidebar-content {\n    padding: 1rem 2rem 3rem 2rem;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    position: relative;\n}\n\n.close-button {\n    position: absolute;\n    top: 1rem;\n    left: 1rem;\n    background: none;\n    border: none;\n    color: #2BA769;\n    font-size: 2rem;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    border-radius: 50%;\n    transition: all 0.3s ease;\n}\n\n.close-button:hover {\n    background-color: rgba(255, 255, 255, 0.1);\n    transform: rotate(90deg);\n}\n\n.sidebar-menu {\n    list-style: none;\n    padding: 0;\n    margin: 1rem 0;\n}\n\n.sidebar-item {\n    margin-bottom: 0.5rem;\n    transform: translateX(20px);\n    opacity: 0;\n    transition: all 0.3s ease;\n}\n\n.mobile-sidebar.active .sidebar-item {\n    transform: translateX(0);\n    opacity: 1;\n}\n\n/* Stagger animation for menu items */\n.mobile-sidebar.active .sidebar-item:nth-child(1) {\n    transition-delay: 0.1s;\n}\n\n.mobile-sidebar.active .sidebar-item:nth-child(2) {\n    transition-delay: 0.15s;\n}\n\n.mobile-sidebar.active .sidebar-item:nth-child(3) {\n    transition-delay: 0.2s;\n}\n\n.mobile-sidebar.active .sidebar-item:nth-child(4) {\n    transition-delay: 0.25s;\n}\n\n.mobile-sidebar.active .sidebar-item:nth-child(5) {\n    transition-delay: 0.3s;\n}\n\n.sidebar-item a {\n    display: block;\n    text-decoration: none;\n    color: black;\n    font-size: 1.1rem;\n    padding: .8rem 1.5rem;\n    border-radius: 12px;\n    transition: all 0.3s ease;\n    background: transparent;\n    font-weight: 500;\n    position: relative;\n}\n\n.sidebar-item a:hover {\n   \n    background: rgba(255, 51, 102, 0.1);\n    transform: translateX(5px);\n}\n\n.sidebar-cta {\n    margin-top: auto;\n    padding: 2rem 1rem;\n    text-align: center;\n    border-top: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.sidebar-cta .cta-button {\n    display: inline-block;\n    padding: 1rem 2rem;\n    background: #00665e;\n    text-decoration: none;\n    border-radius: 8px;\n    font-size: 1.1rem;\n    transition: all 0.3s ease;\n    width: 90%;\n}\n\n.sidebar-cta .cta-button:hover {\n    border-radius: 0 !important;\n    background-color: #0a0a0a !important;\n    border: 1px solid #00ff00 !important; /* var(--dark-neon-green) جایگزین */\n    color: #00ff00;\n    box-shadow: 0 0 20px rgba(57, 255, 20, 0.3);\n}\n\n/* Responsive */\n@media (max-width: 990px) {\n    .mobile-menu {\n        display: block;\n    }\n    \n    .hamburger.active .bar:nth-child(1) {\n        transform: translateY(8px) rotate(45deg);\n    }\n    \n    .hamburger.active .bar:nth-child(2) {\n        opacity: 0;\n    }\n    \n    .hamburger.active .bar:nth-child(3) {\n        transform: translateY(-8px) rotate(-45deg);\n    }\n}\n\n@media (max-width: 480px) {\n    .mobile-sidebar {\n        width: 80%;\n    }\n \n    .nav-link{\n       font-size: 13px;\n           padding: 5px !important;\n           margin:5px 10px !important;\n    }\n    .first-road{\n        font-size: 13px;\n    }\n    .header-phone-inner{\n        padding: 0 5px !important;\n    }\n}\n\n@media (min-width: 480px) {\n    .nav-tabs{\n        justify-content: space-between;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
